import React, { Suspense, useEffect, useState, lazy } from "react";
import GenericTabs from "../../genericComponents/GenericTabs";
import { useSearchParams } from "react-router-dom";

// Lazy load the tab components
const SpotContacts = lazy(() => import("./tabComps/SpotContacts"));
const ReachOut = lazy(() => import("./tabComps/ReachOut"));
const Nurture = lazy(() => import("./tabComps/Nurture"));

function TargetedReachOutComp({ accountContactList }) {
  const [tabsToRender, setTabsToRender] = useState([]);
const [, setSearchParams] = useSearchParams();
    useEffect(() => {
      setSearchParams({
        tab: "targeted_reach_out",
        subTab: "spot_contacts",
      });
    }, []);
    

  useEffect(() => {
    const tabData = [
      {
        tabId:"spot_contacts",
        label: "Spot Contacts",
        comp: <SpotContacts />,
      },
      // {
      //    tabId:"reach_out",
      //   label: "Reach Out",
      //   comp: <ReachOut />,
      // },
      // {
      //    tabId:"nurture",
      //   label: "Nurture",
      //   comp: <Nurture />,
      // },
    ];

    setTabsToRender(tabData);
  }, []);

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <GenericTabs tabs={tabsToRender} />
    </Suspense>
  );
}

export default TargetedReachOutComp;
